import * as React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens'

export function ConfirmDeleteDialog({
  children,
  onConfirm,
  message,
}: {
  children: React.ReactNode
  onConfirm: () => void
  message?: React.ReactNode
}) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false)

  const handleClose = (e?: React.MouseEvent | React.KeyboardEvent) => {
    if (e) {
      e.stopPropagation()
    }
    setOpen(false)
  }

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen)
  }

  const handleConfirm = (e: React.MouseEvent) => {
    e.stopPropagation()
    onConfirm()
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>{t(tokens.ui.confirmation.areYouSure)}</DialogTitle>
        </DialogHeader>
        {message ?? <p>{t(tokens.ui.confirmation.cannotBeUndone)}</p>}
        <DialogFooter>
          <Button
            variant='outline'
            onClick={handleClose}
          >
            {t(tokens.ui.actions.cancel)}
          </Button>
          <Button
            variant='destructive'
            onClick={handleConfirm}
          >
            {t(tokens.ui.actions.delete)} 
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}